import React, { FC } from "react";

import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";

import { TrashCan } from "@/assets/icons";
import { TextInput } from "@/components/atoms";
import { RefSelectInput } from "@/components/molecules";
import { StyledDivider } from "@/styles/components";

import { CompanyFormType } from "../../../../formType";
import { StyledRemoveIconButton } from "../../../../styled";

type EmailFormProps = {
    index: number;
    removeEmail: () => void;
};

const EmailForm: FC<EmailFormProps> = ({ index, removeEmail }) => {
    const { t } = useTranslation();

    const { control } = useFormContext<CompanyFormType>();

    const firstIndex = index === 0;

    return (
        <Grid container data-testid={`email-form-${index}`}>
            {!firstIndex && (
                <Grid item xs={12}>
                    <StyledDivider />
                </Grid>
            )}
            {!firstIndex && (
                <div style={{ position: "relative" }}>
                    <StyledRemoveIconButton aria-label={t("Common.RemoveEmail")} onClick={removeEmail} size="large">
                        <TrashCan />
                    </StyledRemoveIconButton>
                </div>
            )}
            <Grid item xs={12} sm={9}>
                <TextInput
                    name={`contact.emailAddresses.${index}.email`}
                    label={t("Common.Email")}
                    required
                    control={control}
                />
            </Grid>
            <Grid item xs={12} sm={9}>
                <RefSelectInput
                    name={`contact.emailAddresses.${index}.description`}
                    control={control}
                    table="emailType"
                    label={t("Common.Description")}
                    freeSolo
                />
            </Grid>
        </Grid>
    );
};

export default EmailForm;
